var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0013 6.16666C12.5693 6.16666 9.90682 6.84692 8.12753 8.62622C6.34824 10.4055 5.66797 13.068 5.66797 16.5V24.5C5.66797 27.932 6.34824 30.5945 8.12753 32.3738C9.90682 34.1531 12.5693 34.8333 16.0013 34.8333H24.0013C27.4333 34.8333 30.0958 34.1531 31.8751 32.3738C33.6544 30.5945 34.3346 27.932 34.3346 24.5V16.5C34.3346 13.068 33.6544 10.4055 31.8751 8.62622C30.0958 6.84692 27.4333 6.16666 24.0013 6.16666H16.0013ZM7.66797 16.5C7.66797 13.2653 8.32103 11.2611 9.54174 10.0404C10.7625 8.81972 12.7666 8.16666 16.0013 8.16666H24.0013C27.236 8.16666 29.2402 8.81972 30.4609 10.0404C31.6816 11.2611 32.3346 13.2653 32.3346 16.5V24.5C32.3346 27.7347 31.6816 29.7388 30.4609 30.9596C29.2402 32.1803 27.236 32.8333 24.0013 32.8333H16.0013C12.7666 32.8333 10.7625 32.1803 9.54174 30.9596C8.32103 29.7388 7.66797 27.7347 7.66797 24.5V16.5ZM20 14.1667C20.5523 14.1667 21 14.6144 21 15.1667V19.5H25.3346C25.8869 19.5 26.3346 19.9477 26.3346 20.5C26.3346 21.0523 25.8869 21.5 25.3346 21.5H21V25.8333C21 26.3856 20.5523 26.8333 20 26.8333C19.4477 26.8333 19 26.3856 19 25.8333V21.5H14.668C14.1157 21.5 13.668 21.0523 13.668 20.5C13.668 19.9477 14.1157 19.5 14.668 19.5H19V15.1667C19 14.6144 19.4477 14.1667 20 14.1667Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.ce334a04.svg";
export { ForwardRef as ReactComponent };